import Marquee from "react-fast-marquee";
import { Reveal, Eyebrow } from "./Reveal";

export default function Stage() {
  return (
    <section className="py-24 lg:py-32 overflow-hidden" data-testid="stage-section">
      <Marquee speed={35} gradient={false} autoFill className="mb-16 lg:mb-24 select-none">
        <span className="mx-8 text-5xl lg:text-7xl font-light tracking-tight text-gray-100">
          Technology That Preserves Dignity.
        </span>
        <span className="mx-8 text-5xl lg:text-7xl font-serif-italic text-[#7F9F43]/15">
          Technology That Preserves Dignity.
        </span>
      </Marquee>

      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-6">
            <Reveal>
              <Eyebrow number="08" label="Current Stage" />
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight text-[#111827]">
                Built with Purpose.{" "}
                <span className="font-serif-italic text-[#E89A4D]">Guided by Experts.</span>
              </h2>
            </Reveal>
          </div>

          <div className="lg:col-span-5 lg:col-start-8">
            <Reveal delay={0.1}>
              <div className="space-y-5 text-gray-500 leading-relaxed text-base md:text-lg">
                <p>
                  Romii is currently in the <span className="text-[#111827] font-medium">advanced prototype stage</span>.
                  We are actively collaborating with neurologists, psychiatrists, geriatricians,
                  dementia specialists, researchers, caregivers, hospitals, and care institutions
                  to refine the product through real-world feedback before broader deployment.
                </p>
                <p>
                  We are currently inviting selected clinicians, researchers, hospitals, senior
                  living communities, and caregivers to experience an early demonstration and
                  share their valuable insights.
                </p>
                <p>
                  Their expertise will help shape a product that genuinely improves the lives of
                  people living with cognitive decline.
                </p>
              </div>
              <div className="mt-9 flex flex-wrap gap-4">
                <a
                  href="#contact"
                  data-testid="stage-cta-demo"
                  className="inline-flex items-center rounded-full bg-[#7F9F43] px-7 py-3.5 text-sm font-semibold text-white hover:bg-[#6e8b39] hover:-translate-y-0.5 transition-[background-color,transform] duration-300"
                >
                  Request a Demonstration
                </a>
                <a
                  href="#contact"
                  data-testid="stage-cta-collaborator"
                  className="inline-flex items-center rounded-full border border-gray-200 px-7 py-3.5 text-sm font-semibold text-[#111827] hover:border-[#E89A4D] hover:text-[#E89A4D] transition-colors duration-300"
                >
                  Become an Early Collaborator
                </a>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
